<template>
    <ul class="nav_breadcrumbs">
        <li><router-link to="/modules/home">{{lang.LBL_HOME}}</router-link></li>
        <li><router-link to="/modules/ticketsystems/edit">{{lang.LBL_ADD_TICKET}}</router-link></li>
        <li><router-link to="/modules/ticketsystems">{{lang.LBL_VIEW_TICKET}}</router-link></li>
    </ul>
</template>
<script>
import lang from "@/views/modules/TicketSystems/language/en";
export default {
    name: "breadcrumbs",
    data() {
        return {
            lang:[],
           
        }
     },
     mounted() {
        this.lang = lang;
       
    },
    methods:{
       
    }
}
</script>
